import { Search, X } from 'lucide-react';

interface SystemMapSearchProps {
  query: string;
  onQueryChange: (query: string) => void;
  matchCount: number;
  totalCount: number;
}

export default function SystemMapSearch({
  query,
  onQueryChange,
  matchCount,
  totalCount,
}: SystemMapSearchProps) {
  return (
    <div className="relative w-full">
      <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none" />
      <input
        type="search"
        value={query}
        onChange={(e) => onQueryChange(e.target.value)}
        placeholder="Search nodes…"
        className="w-full pl-9 pr-9 py-2 text-sm rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-emerald-500"
      />
      {query ? (
        <button
          type="button"
          onClick={() => onQueryChange('')}
          className="absolute right-2 top-1/2 -translate-y-1/2 p-1 text-gray-400 hover:text-gray-600 dark:hover:text-gray-200"
          aria-label="Clear search"
        >
          <X className="w-4 h-4" />
        </button>
      ) : null}
      {query.trim() ? (
        <span className="sr-only">
          {matchCount} of {totalCount} matching
        </span>
      ) : null}
    </div>
  );
}
